import type { IIconProps } from '@app/components/Icon/types'
import { IconDoubleRightOutlined } from '@app/components-legacy/Icon/IconAntd'
import { CTAColorV2 } from '@app/styles/consts'
import type React from 'react'
import styled from 'styled-components'

const StyledIconDoubleRightOutlined = styled(IconDoubleRightOutlined)`
  svg {
    fill: ${props => props.color ?? CTAColorV2.primary};
    width: ${props => props.size ?? 11}px;
    height: ${props => props.size ?? 11}px;
  }
`

interface IIconDoubleRightProps extends IIconProps {}

const IconDoubleRight: React.FC<IIconDoubleRightProps> = props => (
  <StyledIconDoubleRightOutlined {...props} />
)

export default IconDoubleRight
